// src/pages/geral/UsuarioCad.js
import React, { useState, useEffect } from 'react';

import Input from '../../components/input/Input';
import { useMessage } from '../../contexts/geral/MessageContext';
import { useYesNo } from '../../contexts/geral/YesNoContext';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalHeader from '../../components/modalForm/ModalHeader';
import { useUsuario } from '../../contexts/geral/UsuarioContext';
import { Usuario } from '../../models/geral/Usuario.ts';
import Select from '../../components/input/Select.js';
import UsuarioPerfilEnum, { UsuarioPerfilLabel } from '../../models/geral/UsuarioPerfilEnum.js';
import InputCheck from '../../components/input/InputCheck.js';
import ModalActions, { ModalActionButton } from '../../components/modalForm/ModalActions';

const UsuarioCad = ({ show, onHide }) => {
    const { usuarios, addUsuario, updateUsuario, deleteUsuario, showUsuarioSearch } = useUsuario();
    const [usuario, setUsuario] = useState(new Usuario());
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);

    useEffect(() => {
        if (show) {
            handleNovo();
        }
    }, [show]);

    const handleNovo = () => {
        setUsuario(new Usuario());
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage("Selecione um Usuário para editar!");
            return;
        }
        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!usuario?.id) {
            showMessage("Selecione um Usuário para excluir!");
        } else {
            const resposta = await showYesNo("Deseja excluir o usuário selecionado?");
            if (resposta) {
                await deleteUsuario(usuario.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        try {
            // if (!usuario?.nome || !usuario?.email) {
            //     showMessage("Informe o nome e o email do usuário!", 'warning');
            //     return;
            // }

            if (!usuario?.senha || usuario.senha.length < 5) {
                showMessage("Senha precisa ter pelo menos 5 caracteres!", 'warning');
                return;
            }

            if (!usuario.id) {
                await addUsuario(usuario);
            } else {
                await updateUsuario(usuario);
            }
            handleNovo();
        } catch (error) {
            console.error("Erro ao gravar dados: ", error);
        }
    };

    const handleExit = () => {
        const usuarioSel = usuarios.find(u => u.id.toString() === usuario?.id?.toString());

        if (usuarioSel) {
            setUsuario(usuarioSel);
            handleEditar(usuario?.id);
        } else {
            setUsuario(new Usuario());
        }
    };

    const handleSelectUsuario = async () => {
        const usuarioSel = await showUsuarioSearch();

        if (usuarioSel) {
            handleEditar(usuarioSel.id);
            setUsuario(usuarioSel);
        } else {
            setUsuario(new Usuario());
        }
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} variant="cadastro" onHide={onHide}>
            <ModalHeader title={novoReg ? 'Novo Usuário' : 'Alterar Usuário'} onHide={onHide} />
            <ModalBody>
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Código"
                            value={usuario.id || ''}
                            onChange={(e) => setUsuario({ ...usuario, id: e.target.value })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={handleSelectUsuario}
                        />
                        <Input
                            label="Nome"
                            value={usuario?.nome || ''}
                            onChange={(e) => setUsuario({ ...usuario, nome: e.target.value })}
                            size={300}
                            autoFocus={true}
                        />
                        <Input
                            label="Login"
                            value={usuario?.login || ''}
                            onChange={(e) => setUsuario({ ...usuario, login: e.target.value })}
                            size={200}
                        />
                        <Input
                            label="Senha"
                            type="password"
                            value={usuario?.senha || ''}
                            onChange={(e) => setUsuario({ ...usuario, senha: e.target.value })}
                            size={200}
                        />
                        <Input
                            label="Email"
                            type="email"
                            value={usuario?.email || ''}
                            onChange={(e) => setUsuario({ ...usuario, email: e.target.value })}
                            size={300}
                        />
                        <Input
                            label="Telefone"
                            value={usuario?.telefone || ''}
                            onChange={(e) => setUsuario({ ...usuario, telefone: e.target.value })}
                            size={150}
                        />

                        <Select
                            label="Perfil"
                            value={usuario.perfil ?? UsuarioPerfilEnum.Nenhum}
                            size={170}
                            onChange={(e) =>
                                setUsuario({ ...usuario, perfil: Number(e.target.value) })
                            }
                            options={Object.entries(UsuarioPerfilLabel).map(([value, label]) => ({
                                value: Number(value),
                                label,
                            }))}
                            style={{ marginRight: '20px' }}
                        />

                        <InputCheck                            
                            id="usuario-administrador"
                            label="Administrador"
                            checked={usuario.admin}
                            onChange={(e) => setUsuario({ ...usuario, admin: e.target.checked })}
                        />

                        <InputCheck
                            id="usuario-somente-terminal"
                            label="Somente terminal"
                            checked={usuario.somenteTerminal ?? false}
                            onChange={(e) => setUsuario({ ...usuario, somenteTerminal: e.target.checked })}
                        />

                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <ModalActions >
                    <ModalActionButton className="btn btn-primary" onClick={handleSave} action="save">
                        Salvar
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-danger" onClick={handleDelete} disabled={novoReg} action="delete">
                        Excluir
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-secondary" onClick={handleNovo} disabled={novoReg} action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>
        </ModalContainer>
    );
};

export default UsuarioCad;
